import drawMultilineText from "./drawMultilineText";

const drawFeatureName = (
  ctx: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  isHovered: boolean,
) => {
  ctx.shadowColor = "#000";
  ctx.shadowBlur = 5;
  ctx.shadowOffsetX = 0;
  ctx.shadowOffsetY = 0;

  // Draw text under the image
  ctx.fillStyle = isHovered ? "#fdbb2c" : "#fff";
  ctx.font = "14px Arial";
  ctx.textAlign = "center";
  drawMultilineText(ctx, text, x, y, 20);
};

export default drawFeatureName;
